"use client";

import React from "react";
import SafeLink from "../SafeLink";

interface CustomCheckboxProps {
  name: string;
  isChecked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  link?: string;
  textColorClass?: string;
  linkColorClass?: string;
  className?: string;
}

const CheckIcon = (
  <svg
    className="w-4 h-4 text-white pointer-events-none"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={3}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  name,
  isChecked,
  onChange,
  link = "/privacy",
  textColorClass = "text-black",
  linkColorClass = "text-[#FF7C22]",
  className = "",
}) => {
  const checkboxId = name;

  return (
    <label
      htmlFor={checkboxId}
      className={`flex items-center gap-2 cursor-pointer ${className}`}
    >
      <div className="relative w-5 h-5 flex-shrink-0">
        <input
          id={checkboxId}
          name={name}
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          className="
            peer
            w-5 h-5
            rounded border-2 border-gray-400 cursor-pointer
            checked:bg-[#FF7C22] checked:border-[#FF7C22]
            appearance-none
          "
        />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity">
          {CheckIcon}
        </div>
      </div>

      <span className={`text-sm ${textColorClass} leading-tight`}>
        Я соглашаюсь с{" "}
        <SafeLink href={link} className={`${linkColorClass} underline`}>
          политикой конфиденциальности
        </SafeLink>
      </span>
    </label>
  );
};
